import React, { useState, useEffect } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useSpring, animated } from 'react-spring';
import { useLang } from './LanguageContext';
import t from './translations';

const useTypingEffect = (titles, lang) => {
  const [displayed, setDisplayed] = useState('');
  const [titleIndex, setTitleIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    setDisplayed('');
    setTitleIndex(0);
    setCharIndex(0);
    setDeleting(false);
  }, [lang]);

  useEffect(() => {
    const current = titles[titleIndex];

    if (!deleting && charIndex < current.length) {
      const timer = setTimeout(() => {
        setDisplayed(current.slice(0, charIndex + 1));
        setCharIndex(charIndex + 1);
      }, 80);
      return () => clearTimeout(timer);
    }

    if (!deleting && charIndex === current.length) {
      const timer = setTimeout(() => setDeleting(true), 2000);
      return () => clearTimeout(timer);
    }

    if (deleting && charIndex > 0) {
      const timer = setTimeout(() => {
        setDisplayed(current.slice(0, charIndex - 1));
        setCharIndex(charIndex - 1);
      }, 45);
      return () => clearTimeout(timer);
    }

    if (deleting && charIndex === 0) {
      setDeleting(false);
      setTitleIndex((titleIndex + 1) % titles.length);
    }
  }, [charIndex, deleting, titleIndex, titles]);

  return displayed;
};

const Home = () => {
  const { lang } = useLang();
  const { home } = t[lang];
  const animation = useSpring({ opacity: 1, from: { opacity: 0 } });
  const typedTitle = useTypingEffect(home.titles, lang);

  return (
    <animated.section id="home" className="hero-section" style={animation}>
      <HelmetProvider>
        <img src="/avatar.jpg" alt="Akash Balani" className="hero-avatar" />
        <h2 className="hero-name">Akash Balani</h2>
        <h3 className="home-subtitle">
          <span className="typing-text">{typedTitle}</span>
          <span className="typing-cursor">|</span>
          <span className="typing-suffix"> {home.suffix}</span>
        </h3>
        <Helmet>
          <meta name="description" content="Portfolio of Akash Balani, Systems & Cloud Engineer at Amazon Robotics." />
        </Helmet>
        <p>{home.description}</p>
        <div className="cta">
          <p>
            <a href="#work">{home.cta_work}</a>
            &nbsp;·&nbsp;
            <a href="#contact">{home.cta_contact}</a>
          </p>
        </div>
      </HelmetProvider>
    </animated.section>
  );
};

export default Home;
